import React, { useEffect, useMemo } from 'react';
import { Link } from '@ontruck/orc';

import LoginForm from 'components/auth/LoginForm';
import Footer from 'pages/Login/footer';
import { useTranslation } from 'react-i18next';
import { REGISTER_FORM_LINK } from 'pages/Login/Login.constants';
import { i18n } from 'i18n';
import { OnTruckLogo } from 'refactored/ui/icons';
import { IS_TENANT, isTenantByName } from 'tenant/utils';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const Login = ({ className }) => {
  const { t } = useTranslation('Login');
  const { language } = i18n;

  useEffect(() => {
    const lng = getTenantPreLoginConfig().language;
    if (lng) i18n.changeLanguage(lng);
  }, []);

  const registerFormLink = useMemo(() => {
    return REGISTER_FORM_LINK[language] || REGISTER_FORM_LINK.es;
  }, [language]);

  return (
    <div className={`${className} public-page`}>
      <section className="main" role="main">
        <OnTruckLogo />
        <LoginForm />
        {!IS_TENANT && !isTenantByName('xpo') && (
          <>
            <p className="info">
              {t('signin_info')}&nbsp;
              <Link href={registerFormLink} text={t('signin_info_link')} />
            </p>
            <p className="info">{t('info')}</p>
          </>
        )}
      </section>
      <Footer t={t} />
    </div>
  );
};

export default Login;
